import includes from "lodash/includes";
import { combineActions, handleActions } from "redux-actions";

import { findById, updateById } from "utils";

import { defaultState } from "../configureStore";

const updateDealBrokerCount = (assets, action) =>
  assets.map((a) => {
    let asset = { ...a };
    if (
      includes(action.meta.assetIDs, a.id) &&
      !includes(a.brokerCompanyNames, action.payload.user.company.name)
    ) {
      asset = {
        ...a,
        totalBrokerCompanies: a.totalBrokerCompanies + 1,
        brokerCompanyNames: [...(a.brokerCompanyNames || []), action.payload.user.company.name],
      };
    }

    return asset;
  });

const assetReducer = handleActions(
  {
    ASSETS_GET: {
      PENDING: () => ({
        assets: [],
        totalPages: 0,
        currentPage: 0,
        spaces: {},
      }),
      FULFILLED: (_, { meta: { isFiltering, page }, payload }) => ({
        assets: payload.assets.map((asset) => ({
          ...asset,
          isSpacesExpanded: isFiltering,
          spaceIds: payload.spaceIds.filter((s) => s.assetId === asset.id).map((s) => s.id),
        })),
        totalPages: payload.totalPages,
        currentPage: page,
      }),
    },
    ASSET_GET: {
      PENDING: () => ({
        asset: defaultState.asset,
        spaces: {},
        floorplans: [],
      }),
      FULFILLED: (_, action) => ({
        asset: action.payload.asset,
      }),
    },
    ASSET_NAMES_GET: {
      PENDING: () => ({
        assetNames: [],
      }),
      FULFILLED: (_, action) => ({
        assetNames: action.payload.assets,
      }),
    },
    ASSET_SUBSCRIBE: {
      FULFILLED: (state, action) => ({
        assets: updateById(state.assets, {
          id: action.meta.assetID,
          subscribed: true,
        }),
        asset: updateById(state.asset, {
          id: action.meta.assetID,
          subscribed: true,
        }),
      }),
    },
    ASSET_UNSUBSCRIBE: {
      FULFILLED: (state, action) => ({
        assets: updateById(state.assets, {
          id: action.meta.assetID,
          subscribed: false,
        }),
        asset: updateById(state.asset, {
          id: action.meta.assetID,
          subscribed: false,
        }),
      }),
    },
    ASSET_PORTFOLIO_CHANGE: {
      FULFILLED: (state, action) => ({
        asset: {
          ...state.asset,
          portfolio: action.payload.asset.portfolio,
        },
      }),
    },

    ASSET_DEALS_TOGGLE: (state, action) => {
      const asset = findById(state.assets, action.meta.assetID);

      return {
        assets: updateById(state.assets, {
          ...asset,
          isDealsExpanded: !asset.isDealsExpanded,
          isSpacesExpanded: false,
        }),
      };
    },

    ASSET_DEALS_GET: {
      PENDING: ({ assets }, { meta }) => {
        const asset = assets.find((a) => a.id === meta.assetID);

        return {
          assets: updateById(assets, {
            ...asset,
            isLoadingDeals: true,
          }),
        };
      },
      FULFILLED: ({ assets }, { meta }) => {
        const asset = assets.find((a) => a.id === meta.assetID);

        return {
          assets: updateById(assets, {
            ...asset,
            isLoadingDeals: false,
          }),
        };
      },
    },

    ASSET_SPACES_TOGGLE: (state, action) => {
      const { id, isSpacesExpanded } = findById(state.assets, action.meta.assetID);

      return {
        assets: updateById(state.assets, {
          id,
          isDealsExpanded: false,
          isSpacesExpanded: !isSpacesExpanded,
        }),
      };
    },

    ASSET_SPACES_TOGGLE_ALL: (state) => ({
      assets: state.assets.map((asset) => ({
        ...asset,
        isDealsExpanded: false,
        isSpacesExpanded: !asset.isSpacesExpanded,
      })),
    }),

    ASSET_CREATE: {
      FULFILLED: () => ({
        isAssetModalOpen: false,
      }),
    },
    USER_INVITE: {
      FULFILLED: (state, action) => ({
        assets: updateDealBrokerCount(state.assets, action),
      }),
    },
    ASSET_UPDATE: {
      FULFILLED: (_, action) => ({
        asset: action.payload.asset,
      }),
    },

    [combineActions("ASSET_PICTURE_UPDATE_FULFILLED", "ASSET_PICTURE_CREATE_FULFILLED")]: (
      { asset },
      { payload: { picture } }
    ) => ({
      asset: {
        ...asset,
        avatar: picture.isPrimary ? picture.url : asset.avatar,
      },
    }),
    ASSET_SORT: (_, { meta: { sort } }) => ({
      assetSort: sort,
    }),
  },
  {},
  { namespace: "_" }
);

export default assetReducer;
